import './App.css';
import { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import MainContent from './components/MainContent';
import CartPage from './components/CartPage';
import Footer from './components/Footer';

function App() {
  const [activePage, setActivePage] = useState('home');

  return (
    <div className="app">
      <Navbar activePage={activePage} setActivePage={setActivePage} />
      <Routes>
        <Route path="/cart" element={<CartPage setActivePage={setActivePage} />} />
        <Route path="/" element={<MainContent activePage={activePage} setActivePage={setActivePage} />} />
      </Routes>
      <Footer setActivePage={setActivePage} />
    </div>
  );
}

export default App;
